export default __webpack_public_path__ + "static/JiWooB-e6f4a5f21d39c4a223a9f28fc3eef031.png";